import { createContext } from 'react';
import { UserPreferences, DEFAULT_PREFERENCES } from '../types';

export interface UserPreferencesContextType {
    preferences: UserPreferences;
    loading: boolean;
    /** True once the signed-in user's saved preferences have been read. Nothing is saved before that. */
    loaded: boolean;
    fetch: () => Promise<void>;
    update: (partial: Partial<UserPreferences>) => Promise<void>;
    updateColumnState: (pageKey: string, columnState: any[]) => void;
    /** Records a deliberate column resize. See `UserPreferences.columnWidths`. */
    updateColumnWidths: (pageKey: string, widths: Record<string, number>) => void;
    /** Saves one dashboard setting. See `UserPreferences.dashboard`. */
    updateDashboardPref: (key: string, value: unknown) => void;
}

const UserPreferencesContext = createContext<UserPreferencesContextType>({
    preferences: DEFAULT_PREFERENCES,
    loading: false,
    loaded: false,
    fetch: () => Promise.resolve(),
    update: () => Promise.resolve(),
    updateColumnState: () => {},
    updateColumnWidths: () => {},
    updateDashboardPref: () => {}
});

export default UserPreferencesContext;
